

































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import {isEqual,cloneDeep} from "lodash"
import {NavigationGuardNext, RawLocation, Route} from 'vue-router'
import { v4 as uuidv4 } from 'uuid'
import Tooltip from '@/components/UI/Tooltip.vue';
import BreadCrumbs from '@/components/UI/BreadCrumbs.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IPencil from '@/components/icons/IPencil.vue'
import ICopy from '@/components/icons/ICopy.vue'
import IBack from '@/components/icons/IBack.vue'
import ISave from '@/components/icons/ISave.vue'
import ICheck from '@/components/icons/ICheckContactBlock.vue'
import IClose from '@/components/icons/IClose.vue'
import IRestore from '@/components/icons/IRestore.vue'
import IInfo from '@/components/icons/IInfo.vue'
import draggable from 'vuedraggable'
import SurveyQuestion from '@/components/lfs/Surveys/Questions/SurveyQuestion.vue'
import DetailSideBar from '@/components/lfs/Surveys/Questions/DetailSideBar.vue'
import Modal from '@/components/UI/Modal.vue';
import FullDialog from '@/components/UI/FullDialog.vue';

const surveys = namespace('surveys')
const dialog = namespace('dialog')
const forms = namespace('forms')
const event = namespace('event')

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

@Component({
  name: "Survey",
  components: {
    Tooltip,
    BreadCrumbs,
    BtnDefault,
    'i-pencil': IPencil,
    'i-copy': ICopy,
    'i-back': IBack,
    'i-save': ISave,
    'i-check': ICheck,
    'i-close': IClose,
    'i-restore': IRestore,
    'i-info': IInfo,
    draggable,
    SurveyQuestion,
    DetailSideBar,
    Modal,
    FullDialog
  }
})
export default class Survey extends Vue {
  @surveys.Action('loadSurvey') protected loadSurvey:any
  @surveys.Action('showEditAlert') protected showEditAlert:any
  @surveys.Action('createSurvey') protected createSurvey:any
  @surveys.Action('updateSurvey') protected updateSurvey:any
  @surveys.Getter('survey') protected survey: any
  @surveys.Getter('stateCurrentSurvey') protected stateCurrentSurvey: any
  @surveys.Mutation('setSurvey') protected setSurvey: any
  @surveys.Mutation('setCurrentSurvey') protected setCurrentSurvey: any

  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetSubtitleDialog') protected SetSubtitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any
  @event.Getter('isCurrent') protected isCurrent: any

  questions:any = []
  currentQuestions:any = []
  deletedQuestion:any = []
  deletedAnswer:any = []

  routeReserve:RawLocation | null = null

  currentSurvey:any = []

  notChange:boolean = false
  isChangeQuestion:boolean = false

  currentComposedQuestion:any = []
  composedQuestions:any = []
  decomposedQuestions:any = []

  drag:boolean = false
  isEditTitle:boolean = false
  isActive:boolean = false
  title:string = ''
  countShards:number = 0
  signature:any = {}
  modal:any = {
    deleteQuestion: false,
    deleteAnswer:false,
    isCurrent: false,
    isChange: false,
    isError: false
  }
  currentQuestion:any = {}

  get titleSurvey() {
    return this.$t('toolbar.surveys')
  }

  get isNotChange() {
    return (isEqual(this.currentSurvey, this.survey) && isEqual(this.currentComposedQuestion, this.composedQuestions)) || this.notChange || !this.currentQuestions || !this.composedQuestions
  }

  get hasSignature() {
    return this.signature.order !== undefined
  }

  get deleteQuestionTitle() {
    return this.deletedQuestion.type != 'text_container' ? this.$t('surveys.modal.deleteQuestion.title.question') :
           this.deletedQuestion.order == '777777777' ? this.$t('surveys.modal.deleteQuestion.title.signature') :
           this.$t('surveys.modal.deleteQuestion.title.comment')
  }

  @Watch('fullDialogShow')
  setQuestion() {
    if(!this.fullDialogShow) {
      this.composeQuestions(this.stateCurrentSurvey.survey.questions)
    }
  }

  beforeMount() {
    window.addEventListener('beforeunload', (event) => {
      if (this.isNotChange) return

      event.preventDefault()
      event.returnValue = ''
    })
  }

  async mounted() {
    if(this.survey.length == 0) {
      await this.loadSurvey(this.$route.params.survey)
    } else {
      if(this.$route.params.survey == this.survey.survey.id) {
      } else {
        await this.loadSurvey(this.$route.params.survey)
      }
    }
    this.composeQuestions(this.survey.survey.questions)
    this.currentComposedQuestion = cloneDeep(this.composedQuestions)
    this.countShards = this.survey.countShards
    this.currentSurvey = cloneDeep(this.survey)
  }

  destroyed() {
    window.removeEventListener('beforeunload', (event) => {
      if (this.isNotChange) return

      event.preventDefault()
      event.returnValue = ''
    })
  }

  beforeRouteLeave(to: RawLocation, from: RawLocation, next: NavigationGuardNext) {
    if(!this.isNotChange && this.survey.isEdit) {
      this.modal.isChange = true
      this.routeReserve = to
    } else {
      next()
    }
  }

  nextPage() {
    this.modal.isChange = false
    this.survey.isEdit = false
    this.notChange = true
    this.survey.survey = cloneDeep(this.currentSurvey.survey)
    this.currentSurvey = cloneDeep(this.survey)
    this.composeQuestions(this.survey.survey.questions)
    if(this.routeReserve) {
      this.$router.push(this.routeReserve)
    }
  }

  composeQuestions(questions:any) {
    this.composedQuestions = []
    this.resetQuestions(questions)
    questions.forEach((question:any, index:number) => {
      if(question.order != '777777777') {
        this.checkQuestion(question, 0, index)
        question.order = ++index
      } else {
        this.signature = question
        this.signature.id = uuidv4()
      }
      question.answers.forEach((answer:any) => {
        answer.isEdit = false
      })
    })
    questions.forEach((question:any) => {
      if(!question.include && question.order != '777777777') this.composedQuestions.push(question)
    })
  }

  resetQuestions(questions:any) {
    questions.forEach((question:any) => {
      question.count = 0
      question.include = false
    })
  }

  checkQuestion(question: any, count:number, questionIndex:number = 0) {
    if(question.count === undefined) {
      question.count = count
    } else if(count > question.count) {
      question.count = count
    }
    if(!question.id) {
      question.id = uuidv4()
    }
    question.answers.forEach((answer:any) => {
      answer.includeQuestions.forEach((includeQuestion:any, index:number) => {
        let currentQuestion = this.survey.survey.questions.filter((q:any) => {
          return q.id == includeQuestion || q.id == includeQuestion.id
        })
        if(currentQuestion.length) {
          this.checkQuestion(currentQuestion[0], count + 1)
          currentQuestion[0].include = true
          answer.includeQuestions[index] = currentQuestion[0]
        }
      })
    })
  }

  editSurveyOpenModal() {
    if(this.isCurrent) {
      this.modal.isCurrent = true
    } else {
      this.editSurvey()
    }
  }

  editSurvey() {
    this.survey.isEdit = true
    this.notChange = false
    this.modal.isCurrent = false
    this.currentSurvey = cloneDeep(this.survey)
    this.showEditAlert(this.$t('tooltip.surveys.isNotAccess'))
  }

  changeQuestion() {
    this.composeQuestions(this.currentSurvey.survey.questions)
    this.isChangeQuestion = !this.isChangeQuestion
  }

  addQuestion() {
    this.currentSurvey.survey.questions = this.composedQuestions
    this.setCurrentSurvey(this.currentSurvey)
    this.setOptions({
      id: this.survey.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addQuestion'))
    this.SetSubtitleDialog('')
    this.SetFormSDialog('AddQuestionForm')
    this.SetFullDialogShow(true)
  }

  addSignature() {
    this.currentSurvey.survey.questions = this.composedQuestions
    this.setCurrentSurvey(this.currentSurvey)
    this.setOptions({
      id: this.survey.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addSignature'))
    this.SetFormSDialog('AddSignatureForm')
    this.SetFullDialogShow(true)
  }

  addComment() {
    this.currentSurvey.survey.questions = this.composedQuestions
    this.setCurrentSurvey(this.currentSurvey)
    this.setOptions({
      id: this.survey.survey.id
    })
    this.SetTitleDialog(this.$t('surveys.dialog.addComment'))
    this.SetFormSDialog('AddComentForm')
    this.SetFullDialogShow(true)
  }

  /* Question */

  openModalDeleteQuestion(question:any) {
    this.modal.deleteQuestion = true
    this.deletedQuestion = {...question}
  }

  deleteQuestion() {
    this.modal.deleteQuestion = false
    if(this.deletedQuestion.order == '777777777') {
      this.signature = {}
    }
    this.stateCurrentSurvey.survey.questions = this.stateCurrentSurvey.survey.questions.filter((question:any) => {
      return question.id != this.deletedQuestion.id
    })
    this.composeQuestions(this.stateCurrentSurvey.survey.questions)
    this.isActive = false
  }

  addAnswers(question:any) {
    this.setOptions(question)
    this.SetTitleDialog(this.$t('surveys.dialog.addAnswers'))
    this.SetFormSDialog('AddAnswersForm')
    this.SetFullDialogShow(true)
  }

  openModalDeleteAnswer(question:any, answer:any) {
    this.modal.deleteAnswer = true
    this.deletedAnswer = {...answer}
    this.deletedQuestion = {...question}
  }

  deleteAnswer() {
    this.modal.deleteAnswer = false
    this.survey.survey.questions.map((q:any) => {
      if(q.id == this.deletedQuestion.id) {
        q.answers = q.answers.filter((a:any) => {
          return a.id != this.deletedAnswer.id
        })
      }
      return q
    })
    this.composeQuestions(this.survey.survey.questions)
  }

  editAnswer(answer:any, question:any) {
    this.composedQuestions.forEach((question:any) => {
      question.answers.forEach((answer:any) => {
        answer.isEdit= false
      })
    })
    answer.isEdit = true
    this.isChangeQuestion = !this.isChangeQuestion
  }

  changeAnswer(answer:any, currentAnswer:any) {
    this.isChangeQuestion = !this.isChangeQuestion
    answer.isEdit = false
    answer.value = currentAnswer.value
  }

  cancelEditAnswer(answer:any) {
    answer.isEdit = false
    this.isChangeQuestion = !this.isChangeQuestion
  }

  chooseQuestion(question:any) {
    this.currentSurvey.survey.questions = this.composedQuestions
    this.setCurrentSurvey(this.currentSurvey)
    this.isActive = this.currentQuestion.id != question.id
    if(this.currentQuestion.id == question.id) {

    }
    if(this.survey.isEdit) {
      this.questions.map((q:any) => {
        if(question.id != q.id) {
          q.active = false
        } else {
          q.active = !q.active
        }
      })
      if(this.isActive) {
        this.currentQuestion = question
      } else {
        this.currentQuestion = []
      }
    }
  }

  async changeIncludes(answer:any, title:string, question:any) {
    this.currentQuestions = []
    let questions = cloneDeep(this.composedQuestions)
    await this.decomposeQuestions(questions)
    this.setOptions({
      questions: this.currentQuestions,
      answer: answer,
      currentQuestion: question
    })
    this.SetSubtitleDialog(title)
    this.SetTitleDialog(answer.value)
    this.SetFormSDialog('ChangeIncludeQuestionForm')
    this.SetFullDialogShow(true)
  }

  deleteIncludeQuestion(answer:any, includeQuestion:any) {
    answer.includeQuestions = answer.includeQuestions.filter((q:any) =>  q.id != includeQuestion.id)
    includeQuestion.count = 0
    this.questions.push(includeQuestion)
    this.composeQuestions(this.survey.survey.questions)
  }

  back() {
    this.$router.push(
      {
        name: 'Surveys'
      }
    )
  }

  changeArchive() {
    let payload = {
      id: this.survey.survey.id,
      params: {
        isArchived: false
      }
    }
    this.updateSurvey(payload)
  }

  editTitle() {
    this.isEditTitle = true
    this.title = this.survey.survey.title
  }

  decomposeQuestions(questions:any) {
    questions.forEach((question:any) => {
      if(typeof(question) != 'string') {
        question.include = false
        delete question.count
        this.currentQuestions.push(question)
        question.answers.forEach((answer:any) => {
          this.decomposeQuestions(answer.includeQuestions)
          let questions:any = []
          answer.includeQuestions.forEach((includeQuestion:any) => {
            questions.push(includeQuestion.id)
          })
          answer.includeQuestions = questions
        })
      }
    })
  }

  async copy() {
    this.modal.isError = false
    this.getQuestionsForSave()
    let params = {
      title: this.$t('surveys.copy') + ' ' + this.survey.survey.title,
      questions: this.currentQuestions,
      hasSignature: this.survey.survey.hasSignature,
      isArchived: false,
      isActive: false,
      message: this.$t('surveys.alert.addCopy')
    }
    await this.createSurvey(params)
    this.$router.push(
      {
        name: 'Survey', params: {
          survey: this.survey.survey.id
        }
       }
    )
    this.countShards = this.survey.countShards
  }

  async cancelEdit() {
    await this.setSurvey({
      isEdit: false,
      survey: this.currentSurvey
    })
    this.composeQuestions(this.survey.survey.questions)
  }

  getQuestionsForSave() {
    this.currentQuestions = []
    let questions = cloneDeep(this.composedQuestions)
    this.decomposeQuestions(questions)
    this.currentQuestions.forEach((question:any, index:number) => {
      if(question.isNew) {
        delete question.isNew
      }
      if(question.type == 'text_container') {
        question.specify = 'default'
      }
      question.order = ++index
      question.active = false
      question.answers.forEach((answer:any, index:number) => {
        answer.order = ++index
        if(!answer.type || !answer.type.length) answer.type = 'regular'
      })
    })
    if(this.signature.order) this.currentQuestions.push(this.signature)
  }

  async saveSurvey() {
    await this.getQuestionsForSave()
    let payload = {
      id: this.survey.survey.id,
      params: {
        title: this.survey.survey.title,
        questions: this.currentQuestions,
        hasSignature: this.hasSignature
      }
    }
    let response = await this.updateSurvey(payload)
    if(response && response.response.data.error == 'has_answers_for_survey') {
      this.modal.isError = true
    }
    this.questions = []
    this.survey.survey.questions.forEach((question:any, index:number) => {
      question.active = false
      if(question.order != '777777777') {
        //this.checkQuestion(question, 0, index)
      } else {
        this.signature = question
      }
    })
    this.survey.survey.questions.forEach((question:any) => {
      if(!question.include && question.order != '777777777') this.questions.push(question)
    })
    this.isActive = false
    this.currentQuestion = []
    this.composeQuestions(this.survey.survey.questions)
    this.currentSurvey = cloneDeep(this.survey)
    this.currentComposedQuestion = cloneDeep(this.composedQuestions)
    this.notChange = true
  }

  saveTitle() {
    this.survey.survey.title = this.title
    this.isEditTitle = false
  }

}
